import { MutationTree } from 'vuex';
import { DashboardState, TaskInfo, AlertInfo, SystemMessages } from './types';
import * as types from './mutation-types';
import { ErrorDetail } from '../../types';

// エラーをクリアする
const resetErrors = (state: DashboardState): void => {
    const indexState = state.taskIndex;
    indexState.error = false;
    indexState.errorTitle = undefined;
    indexState.errorDetails = undefined;

    const alertState = state.alertIndex;
    alertState.error = false;
    alertState.errorTitle = undefined;
    alertState.errorDetails = undefined;
};

export const mutations: MutationTree<DashboardState> = {
    // タスク一覧系
    [types.TASK_INDEX_START](state) {
        resetErrors(state);
        const indexState = state.taskIndex;
        indexState.isProcessing = true;
        indexState.isFetchSuccess = false;
    },

    [types.TASK_INDEX_SUCCESS](state, payload: { count: number; tasks: Array<TaskInfo> }) {
        state.taskCount = payload.count;
        state.taskList = payload.tasks;

        const indexState = state.taskIndex;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = true;
    },

    [types.TASK_INDEX_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const indexState = state.taskIndex;
        indexState.errorTitle = payload.errorTitle;
        indexState.errorDetails = payload.errorDetails;
        indexState.error = true;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = false;
    },

    // アラート一覧系
    [types.ALERT_INDEX_START](state) {
        resetErrors(state);
        const indexState = state.alertIndex;
        indexState.isProcessing = true;
        indexState.isFetchSuccess = false;
    },

    [types.ALERT_INDEX_SUCCESS](state, payload: Array<AlertInfo>) {
        state.alertList = payload;

        const indexState = state.alertIndex;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = true;
    },

    [types.ALERT_INDEX_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const indexState = state.alertIndex;
        indexState.errorTitle = payload.errorTitle;
        indexState.errorDetails = payload.errorDetails;
        indexState.error = true;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = false;
    },

    // システムメッセージ一覧系
    [types.SYSTEM_MESSAGE_INDEX_START](state) {
        resetErrors(state);
        const systemMessageIndexState = state.systemMessageIndex;
        systemMessageIndexState.isProcessing = true;
        systemMessageIndexState.isFetchSuccess = false;
    },

    [types.SYSTEM_MESSAGE_INDEX_SUCCESS](state, payload: SystemMessages) {
        state.systemMessageList = payload;

        const systemMessageIndexState = state.systemMessageIndex;
        systemMessageIndexState.isProcessing = false;
        systemMessageIndexState.isFetchSuccess = true;
    },

    [types.SYSTEM_MESSAGE_INDEX_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const systemMessageIndexState = state.systemMessageIndex;
        systemMessageIndexState.errorTitle = payload.errorTitle;
        systemMessageIndexState.errorDetails = payload.errorDetails;
        systemMessageIndexState.error = true;
        systemMessageIndexState.isProcessing = false;
        systemMessageIndexState.isFetchSuccess = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const indexState = state.taskIndex;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = false;
    },

    [types.CLEAR_ALL](state) {
        resetErrors(state);

        state.taskList = undefined;
        state.taskCount = 0;
        state.alertList = undefined;
        state.systemMessageList = undefined;
    },
};
